import * as React from 'react';

const GooglePlayBrandIcon = ({
  width = 22,
  height = 22,
  ...props
}: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22" fill="none" {...props}>
    <path
      d="M11.5677 11.0187L13.9519 8.46412L4.69876 3.46855C4.64199 3.41178 4.52846 3.41178 4.35815 3.35501L11.5677 11.0187Z"
      fill="white"
    />
    <path
      d="M14.9738 14.7086L18.3231 12.892C18.7204 12.6649 18.9475 12.3243 18.9475 11.8702C18.9475 11.416 18.7204 11.0187 18.3231 10.8484L14.9738 9.0318L12.3057 11.8702L14.9738 14.7086Z"
      fill="white"
    />
    <path
      d="M3.27956 3.86594C3.10926 4.03624 3.05249 4.26331 3.05249 4.49038V19.25C3.05249 19.4771 3.10926 19.7042 3.27956 19.9312L10.7729 11.8702L3.27956 3.86594Z"
      fill="white"
    />
    <path
      d="M11.5677 12.7217L4.35815 20.3854C4.47169 20.3854 4.58523 20.3286 4.69876 20.2718L13.9519 15.2763L11.5677 12.7217Z"
      fill="white"
    />
  </svg>
);

export default GooglePlayBrandIcon;
